import React, {useEffect, useRef, useState} from 'react';
import {NavLink} from 'react-router-dom';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faXmark} from '@fortawesome/free-solid-svg-icons';

import {communityLink, routeNames} from '../../../constants/routes';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import './styles.less';

interface IProps {
  auth: boolean;
}

const Menu = ({auth}: IProps) => {
  const [mobileMenu, setMobileMenu] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(true);

  const {screenWidth} = useWindowDimensions();

  const menuBtn = useRef(null);

  useEffect(() => {
    if (screenWidth < 992) {
      setMobileMenu(true);
      setShowMenu(false);
    } else {
      setMobileMenu(false);
      setShowMenu(true);
    }
  }, [screenWidth]);

  const handleClose = (event: MouseEvent): void => {
    if (menuBtn.current && !menuBtn.current.contains(event.target)) {
      setShowMenu(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClose, {capture: true});

    return () => {
      window.removeEventListener('click', handleClose, {capture: true});
    };
  }, [mobileMenu]);

  const handleMenu = () => setShowMenu(!showMenu);

  return (
    <div className='ac-header-menu'>
      {mobileMenu && (
        <button
          ref={menuBtn}
          type='button'
          onClick={handleMenu}
          className='ac-header-menu__btn'
          aria-label='view menu'
        >
          {showMenu ? <FontAwesomeIcon icon={faXmark} /> : <FontAwesomeIcon icon={faBars} />}
        </button>
      )}

      {showMenu && (
        <nav className={mobileMenu ? 'ac-header-menu__mobile-nav' : ''}>
          <ul>
            <li>
              <NavLink to={`${routeNames.hotels}?t=hs`}>Hotels</NavLink>
            </li>
            <li>
              <NavLink to={routeNames.rentalCar}>Cars</NavLink>
            </li>
            <li>
              <NavLink to={routeNames.vanRentals}>Vans</NavLink>
            </li>
            <li>
              <NavLink to={routeNames.mobilityRentals}>Equipment</NavLink>
            </li>
            <li>
              <NavLink to={routeNames.flights}>Flights</NavLink>
            </li>
            {/* <li>
              <NavLink to={routeNames.transfers}>Rides</NavLink>
            </li> */}
            {/* <li>
              <NavLink to={routeNames.travel_ideas}>Travel Ideas</NavLink>
            </li> */}
            <li>
              <NavLink to={routeNames.city_guides}>City Guides</NavLink>
            </li>
            <li>
              {/* <NavLink to={routeNames.community}>Community</NavLink> */}
              <a
                href={`${communityLink}${auth ? '/?automatic_login=true' : ''}`}
                target='_blank'
                rel='noreferrer'
                aria-label='Link to the community forum'
              >
                Community
              </a>
            </li>
          </ul>
        </nav>
      )}
    </div>
  );
};

export default Menu;
